import React, { useEffect, useState } from 'react';
import { InputLabel, MenuItem,TextField, InputAdornment } from '@mui/material';
import { useField, useFormikContext, ErrorMessage } from 'formik';
import { Info } from '@mui/icons-material';
import ApiClient from 'helpers/ApiClient';
import { v4 as uuidv4 } from 'uuid';
interface Props {
    name: string;
    setPcnInfo: any;
    label: string;
    className: string
}
const SelectGroupWrapper: React.FC<Props> = ({
    name,
    setPcnInfo,label
}) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);
    const [pcnsData,setPcnData]=useState([])
    let userData = JSON.parse(localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null");
   const pcnData=()=>{
        ApiClient.get(`pcn?limit=100&userId=${userData.id}&sortBy=desc&sortField=createdAt`)
        .then((res)=>{
            setPcnData(res?.data?.data);
        }).catch((error)=>{
        })
    }
    useEffect(()=>{
        pcnData();
    },[])
    
    const handleChange = (evt: React.MouseEvent) => {
        const { value }: any = evt.target;
        setFieldValue(name, value);
        if(name==='pcnNumber'){
            ApiClient.get(`pcn/${value}`)
            .then((res)=>{
                setPcnInfo(res?.data?.data)
            }).catch((error)=>{
            })
        }
    };
    const configSelect: any = {
        ...field,
        select: true,
        variant: 'outlined',
        fullWidth: true,
        onChange: handleChange
      };
    if (meta && meta.touched && meta.error) {
        configSelect.error = true;
    }
    return (
        <>
            <InputLabel htmlFor="grouped-native-select"
                className={ meta && meta.touched && meta.error ? "error-color vehicleDropdownlabel" : "vehicleDropdownlabel" } >
                {label} <span style={{color:'red'}}>*</span></InputLabel>
                <TextField size="large"   
                    placeholder="Placeholder Text"
                    InputProps={{
                        endAdornment: (
                        <InputAdornment position="end">
                            {(meta.touched && meta.error)&& (
                                <Info sx={{ color: "#DC3545", mr: "13px" }} fontSize="medium" />)
                            }
                        </InputAdornment>
                        )
                    }}
                 {...configSelect}>

                {pcnsData.map((item: any) => {
                return (
                    <MenuItem  key={uuidv4()} value={item?.id}>
                        {item?.pcnNumber}
                    </MenuItem>
                )
                })}
            </TextField>
            <ErrorMessage name={name} component='p' className='select-error error-color fs-14' />
        </>
    );
};
export default SelectGroupWrapper;



